<template>
  <el-card class="card" v-loading="loading">
    <p class="title">{{ $t('data.perform.paymentOverview') }}</p>
    <p class="tip">{{ $t('data.perform.paymentDesc') }}</p>
    <div class="charts">
      <div v-for="(conf, index) in config" :key="index">
        <base-cp-chart :config="conf" :data="data"></base-cp-chart>
      </div>
    </div>
  </el-card>
</template>

<script>
import BaseCpChart from './BaseCpChart.vue'
import dataService from '@/api/data'

export default {
  name: 'CpDataChart',

  components: {
    BaseCpChart
  },

  data() {
    return {
      loading: true,
      config: [
        {
          isAgentN: {
            label: this.$t('data.perform.isAgentN'),
            query: {
              isAgent: 0
            }
          },
          isAgentY: {
            label: this.$t('data.perform.isAgentY'),
            query: {
              isAgent: 1
            }
          }
        },
        {
          isOnlyN: {
            label: this.$t('data.perform.isOnlyN'),
            query: {
              isOnly: 0,
            }
          },
          isOnlyY: {
            label: this.$t('data.perform.isOnlyY'),
            query: {
              isOnly: 1
            }
          },
        },
        {
          canLegalRightsY: {
            label: this.$t('data.perform.canLegalRightsY'),
            query: {
              canLegalRights: 1
            }
          },
          canLegalRightsN: {
            label: this.$t('data.perform.canLegalRightsN'),
            query: {
              canLegalRights: 0
            }
          }
        },
        {
          free: {
            label: this.$t('data.perform.free'),
            query: {
              isFree: 1
            }
          },
          payment: {
            label: this.$t('data.perform.payment'),
            query: {
              isFree: 0
            }
          }
        }
      ],
      data: {}
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      try {
        const { list } = await dataService.queryUploadInfoDtb()
        this.data = list && list[0]
      } catch (err) {
        this.$message.error('获取上传作品版权付费分布情况失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;
}

.tip {
  margin: 10px 0;
  &:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}

.title {
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  color: #002444;
}

.select {
  z-index: 1;
  position: absolute;
  width: 100px;
  top: 50px;
  right: 20px;
}

.charts {
  display: flex;
  & > div {
    flex: 1;
    text-align: center;
    border-right: 1px solid rgba(220,221,222,1);
    &:last-child {
      border-right: none;
    }

  }
}

</style>
